import { useNavigate } from "react-router-dom";
import { t } from "../app/Translate";

const Error = () => {     
    const navigate = useNavigate();
    
    return(
        <div className="container404">
            <div className="errorheader">
                <img  src="/images/Logo-Makos.png" alt='Makos' />
            </div>
            <div className="error-code onlydesktop">{t("error.error")}</div>
            <h1 className="error-title">{t("error.title")}</h1>
            <p className="error-message">
                {t("error.subtitle")}
            </p>

            <div className="buttons">
                <a href="/" className="btn btn-primary">{t("error.btnHome")}</a>
                <button onClick={() => navigate(-1)} className="btn btn-secondary">{t("error.btnBack")}</button>                
            </div>

            <br/><br/><br/>
        </div>
    )
}

export default Error;